import { assertEnv } from "@homeinstead/shared";

const MARKETING_API_KEY_HEADER = "x-marketing-api-key";

function getMarketingApiConfig() {
  const apiKey = assertEnv(
    "AWS_MARKETING_API_KEY",
    process.env.AWS_MARKETING_API_KEY,
  );
  const url = assertEnv(
    "AWS_MARKETING_API_URL",
    process.env.AWS_MARKETING_API_URL,
  );
  return { apiKey, url } as const;
}

export { getMarketingApiConfig, MARKETING_API_KEY_HEADER };
